<ng-container *ngIf="chatClientService.panelOpen$ | async">
  <div
    class="box-chat-client position-fixed d-flex flex-column overflow-hidden bg-white rounded-4"
    role="dialog"
    aria-label="Chat"
  >
    <div class="box-chat-client-body position-relative flex-fill">
      <div
        *ngIf="chatClientService.loading$ | async"
        class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white"
      >
        <div class="spinner-border text-primary" role="status"></div>
      </div>
      <iframe
        *ngIf="safeIframeUrl$ | async as chatUrl"
        class="w-100 h-100 border-0 d-block"
        [src]="chatUrl"
        title="Chat"
        [class.d-none]="chatClientService.loading$ | async"
      ></iframe>
    </div>
  </div>
</ng-container>
